module.exports = __webpack_public_path__ + "img/1524299898.c9ebcce4.jpg";